import "../css/index.css";
import "../../../../packages/siddhast-theme-core/js/shared.js";

/* ─────────────────────────────────────────────────────────
   Siddhast IP — Theme JS
   Accordion · Reveal on Scroll · Reveal Stagger
   Powell methodology: progressive enhancement, no jQuery
   ───────────────────────────────────────────────────────── */

(function () {
    "use strict";

    /* ═══════════ ACCORDION ═══════════ */
    function initAccordion() {
        const triggers = document.querySelectorAll(".accordion-trigger");
        triggers.forEach(function (trigger) {
            trigger.addEventListener("click", function () {
                const item = trigger.closest(".accordion-item");
                if (!item) return;
                const isOpen = item.classList.contains("is-open");
                // Close all open items in same accordion
                const accordion = item.closest(".accordion");
                if (accordion) {
                    accordion.querySelectorAll(".accordion-item.is-open").forEach(function (openItem) {
                        if (openItem !== item) openItem.classList.remove("is-open");
                    });
                }
                item.classList.toggle("is-open", !isOpen);
            });
        });
    }

    /* ═══════════ REVEAL ON SCROLL ═══════════ */
    function initReveal() {
        const items = document.querySelectorAll(".reveal:not(.is-visible)");
        if (!items.length) return;

        // If IntersectionObserver isn't available, just show everything
        if (!("IntersectionObserver" in window)) {
            items.forEach(function (el) { el.classList.add("is-visible"); });
            return;
        }

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });

        items.forEach(function (el) { observer.observe(el); });
    }

    /* ═══════════ REVEAL STAGGER ═══════════ */
    function initRevealStagger() {
        const containers = document.querySelectorAll(".reveal-stagger");
        if (!containers.length) return;

        if (!("IntersectionObserver" in window)) {
            containers.forEach(function (container) {
                container.querySelectorAll(".reveal").forEach(function (el) {
                    el.classList.add("is-visible");
                });
            });
            return;
        }

        const containerObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const children = entry.target.querySelectorAll(".reveal:not(.is-visible)");
                    children.forEach(function (child, i) {
                        setTimeout(function () {
                            child.classList.add("is-visible");
                        }, i * 90);
                    });
                    containerObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.05, rootMargin: "0px 0px -30px 0px" });

        containers.forEach(function (container) { containerObserver.observe(container); });
    }

    /* ═══════════ SCROLL-TO SMOOTH ═══════════ */
    function initHashScroll() {
        document.querySelectorAll('a[href^="#"]').forEach(function (link) {
            link.addEventListener("click", function (e) {
                var id = link.getAttribute("href").slice(1);
                if (!id) return;
                var target = document.getElementById(id);
                if (!target) return;
                e.preventDefault();
                target.scrollIntoView({ behavior: "smooth", block: "start" });
                // Update URL without jump
                history.pushState(null, "", "#" + id);
            });
        });
    }

    /* ═══════════ HEADER SCROLL CLASS ═══════════ */
    function initHeaderScroll() {
        var header = document.querySelector(".navbar-main, .site-header, header");
        if (!header) return;
        function onScroll() {
            header.classList.toggle("is-scrolled", window.scrollY > 30);
        }
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
    }

    /* ═══════════ NAVIGATION LOGIC ═══════════ */
    function initNavigation() {
        const mobileMenuBtn = document.getElementById("mobile-menu-btn");
        const body = document.body;
        const mobileOverlay = document.getElementById("mobile-overlay");
        
        if (mobileMenuBtn && mobileOverlay) {
            mobileMenuBtn.addEventListener("click", function () {
                body.classList.toggle("is-menu-open");
                const isExpanded = mobileMenuBtn.getAttribute("aria-expanded") === "true";
                mobileMenuBtn.setAttribute("aria-expanded", !isExpanded);
                if (!isExpanded) {
                    mobileOverlay.removeAttribute("hidden");
                } else {
                    setTimeout(() => mobileOverlay.setAttribute("hidden", ""), 300); // wait for fade out
                }
            });

            mobileOverlay.addEventListener("click", function () {
                body.classList.remove("is-menu-open");
                mobileMenuBtn.setAttribute("aria-expanded", "false");
                setTimeout(() => mobileOverlay.setAttribute("hidden", ""), 300);
            });
        }

        // Search logic
        const searchBtn = document.getElementById("search-btn");
        const searchOverlay = document.getElementById("search-overlay");
        const searchClose = document.getElementById("search-close");
        const searchInput = document.getElementById("search-overlay-q");

        if (searchBtn && searchOverlay) {
            searchBtn.addEventListener("click", function () {
                searchOverlay.classList.add("is-open");
                if (searchInput) setTimeout(() => searchInput.focus(), 100);
                body.style.overflow = "hidden"; // Prevent scrolling
            });

            if (searchClose) {
                searchClose.addEventListener("click", function () {
                    searchOverlay.classList.remove("is-open");
                    body.style.overflow = "";
                });
            }
        }
    }

    /* ═══════════ INIT ═══════════ */
    function init() {
        initAccordion();
        initReveal();
        initRevealStagger();
        initHashScroll();
        initHeaderScroll();
        initNavigation();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

})();
